import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { BasicTooltip, Icon } from '@livable/saas-react-components';
import { Button, TextField, Typography } from '@mui/material';
import { DataGrid, GridRowEditStopReasons, GridRowModes, GridActionsCellItem } from '@mui/x-data-grid';
import { observer } from 'mobx-react-lite';
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import useAllocationUtilityStyles from '../../AllocationUtility/styles';
const EditIcon = () => /*#__PURE__*/React.createElement(Icon, {
  type: "edit-pencil"
});
const CancelIcon = () => /*#__PURE__*/React.createElement(Icon, {
  type: "close"
});
const SaveIcon = () => /*#__PURE__*/React.createElement(Icon, {
  type: "check"
});
const SubmeterCsvTableModal = observer(_ref => {
  let fileContents = _ref.fileContents,
    saveCallback = _ref.saveCallback,
    sentStatus = _ref.sentStatus,
    submeterFinalStateInfoExt = _ref.submeterFinalStateInfoExt;
  const classes = useAllocationUtilityStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const _useState = useState(10),
    _useState2 = _slicedToArray(_useState, 2),
    pageSize = _useState2[0],
    setPageSize = _useState2[1];
  const _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    rows = _useState4[0],
    setRows = _useState4[1];
  const _useState5 = useState({}),
    _useState6 = _slicedToArray(_useState5, 2),
    rowModesModel = _useState6[0],
    setRowModesModel = _useState6[1];
  const renderCell = (parameter, left) => /*#__PURE__*/React.createElement("span", {
    className: "".concat(classes.cellContent, " ").concat(left && classes.cellLeft)
  }, parameter);
  const renderHeader = (text, rightAlign) => /*#__PURE__*/React.createElement("span", {
    className: rightAlign && classes.rightAlign
  }, text);
  const renderCellTooltip = (parameter, left) => /*#__PURE__*/React.createElement("div", {
    className: classes.overflowCellWrapper
  }, /*#__PURE__*/React.createElement(BasicTooltip, {
    title: parameter,
    placement: "top",
    hideOnMobile: true
  }, /*#__PURE__*/React.createElement("span", {
    className: "".concat(classes.cellContent, " ").concat(left && classes.cellLeft)
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    className: classes.overflowCell
  }, parameter))));
  const handleEditClick = id => () => {
    setRowModesModel(_objectSpread(_objectSpread({}, rowModesModel), {}, {
      [id]: {
        mode: GridRowModes.Edit
      }
    }));
  };
  const handleSaveClick = id => () => {
    setRowModesModel(_objectSpread(_objectSpread({}, rowModesModel), {}, {
      [id]: {
        mode: GridRowModes.View
      }
    }));
  };
  const handleCancelClick = id => () => {
    setRowModesModel(_objectSpread(_objectSpread({}, rowModesModel), {}, {
      [id]: {
        mode: GridRowModes.View,
        ignoreModifications: true
      }
    }));
    const editedRow = rows.find(row => row.unitId === id || row.residentAccountId === id);
    if (typeof editedRow.isEdited !== 'undefined') {
      setRows(rows.filter(row => row.unitId !== id || row.residentAccountId !== id));
    }
  };
  const handleRowEditStop = (params, event) => {
    if (params.reason === GridRowEditStopReasons.rowFocusOut) {
      event.defaultMuiPrevented = true;
    }
  };
  const processRowUpdate = newRow => {
    // transform back Date values into text
    ['startReadDate', 'endReadDate'].forEach(field => {
      if (typeof newRow[field] === 'object') {
        newRow[field] = moment(newRow[field]).format('MM/DD/YYYY');
      }
    });
    // transform back Number values
    ['startMeterRead', 'endMeterRead', 'meterUsage', 'meterRate', 'utilityCharge'].forEach(field => {
      if (isNaN(Number(newRow[field]))) {
        newRow[field] = parseFloat(0);
      }
    });
    // update meterUsage when either startRead or endRead were updated
    if (newRow.startMeterRead && newRow.endMeterRead) {
      const minusValue = Number(newRow.endMeterRead) - Number(newRow.startMeterRead);
      newRow.meterUsage = parseFloat(minusValue).toFixed(2);
    }
    const updatedRow = _objectSpread(_objectSpread({}, newRow), {}, {
      isEdited: true
    });
    const rowsCopy = [...rows];
    rowsCopy.splice(rowsCopy.findIndex(row => !!newRow.accountId && row.accountId === newRow.accountId || !!newRow.unitId && row.unitId === newRow.unitId || !!newRow.residentAccountId && row.residentAccountId === newRow.residentAccountId), 1, updatedRow);
    if (saveCallback) {
      saveCallback(rowsCopy);
    }
    return updatedRow;
  };
  const handleRowModesModelChange = newRowModesModel => {
    setRowModesModel(newRowModesModel);
  };
  useEffect(() => {
    setRows(fileContents || []);
  }, [fileContents]);
  const columns = [{
    field: 'unitName',
    align: 'left',
    // flex: 1,
    maxWidth: 80,
    headerName: 'Unit Number',
    editable: !sentStatus,
    renderCell: params => renderCellTooltip(params.row.unitName, true),
    renderHeader: () => renderHeader(t('allocations.unit_name')),
    sortComparator: (v1, v2) => {
      var _ref2;
      return (_ref2 = '' + v1) === null || _ref2 === void 0 ? void 0 : _ref2.localeCompare(v2, undefined, {
        numeric: true
      });
    }
  }, {
    field: 'fullName',
    align: 'left',
    flex: 0.8,
    headerName: 'Resident name',
    minWidth: 230,
    maxWidth: 270,
    editable: !sentStatus,
    renderCell: params => {
      var _submeterFinalStateIn, _submeterFinalStateIn2, _params$row2;
      const residentName = (_submeterFinalStateIn = submeterFinalStateInfoExt === null || submeterFinalStateInfoExt === void 0 || (_submeterFinalStateIn2 = submeterFinalStateInfoExt.find(i => {
        var _params$row;
        return (params === null || params === void 0 || (_params$row = params.row) === null || _params$row === void 0 ? void 0 : _params$row.residentAccountId) === (i === null || i === void 0 ? void 0 : i.residentAccountId);
      })) === null || _submeterFinalStateIn2 === void 0 ? void 0 : _submeterFinalStateIn2.residentAccountFullName) !== null && _submeterFinalStateIn !== void 0 ? _submeterFinalStateIn : params === null || params === void 0 || (_params$row2 = params.row) === null || _params$row2 === void 0 ? void 0 : _params$row2.fullName;
      return renderCell(residentName);
    },
    renderHeader: () => renderHeader(t('allocations.resident_name'))
  }, {
    field: 'startReadDate',
    align: 'left',
    flex: 0.55,
    headerName: 'Start read\ndate',
    headerAlign: 'left',
    minWidth: 95,
    maxWidth: 100,
    type: 'date',
    valueGetter: params => new Date(params.row.startReadDate),
    valueFormatter: params => moment(params.value).format('MM/DD/YYYY'),
    editable: !sentStatus,
    renderCell: params => renderCell(params.row.startReadDate),
    renderHeader: () => renderHeader(t('allocations.start_read_date'), true)
  }, {
    flex: 0.55,
    field: 'endReadDate',
    align: 'left',
    headerName: 'End read\ndate',
    headerAlign: 'left',
    minWidth: 95,
    maxWidth: 100,
    type: 'date',
    valueGetter: params => new Date(params.row.endReadDate),
    valueFormatter: params => moment(params.value).format('MM/DD/YYYY'),
    editable: !sentStatus,
    renderCell: params => renderCell(params.row.endReadDate),
    renderHeader: () => renderHeader(t('allocations.end_read_date'), true)
  }, {
    field: 'startMeterRead',
    align: 'left',
    flex: 0.4,
    minWidth: 90,
    maxWidth: 120,
    headerName: 'Start\nread',
    headerAlign: 'left',
    type: 'number',
    editable: !sentStatus,
    renderCell: params => renderCell(params.row.startMeterRead, true),
    renderHeader: () => renderHeader(t('allocations.start_read'), false)
  }, {
    field: 'endMeterRead',
    align: 'left',
    flex: 0.4,
    minWidth: 90,
    maxWidth: 120,
    headerName: 'End\nread',
    headerAlign: 'left',
    type: 'number',
    editable: !sentStatus,
    renderCell: params => renderCell(params.row.endMeterRead, true),
    renderHeader: () => renderHeader(t('allocations.end_read'), false)
  }, {
    field: 'meterUsage',
    align: 'left',
    flex: 0.4,
    minWidth: 90,
    maxWidth: 120,
    headerName: 'Utility usage',
    type: 'number',
    editable: !sentStatus,
    renderCell: params => renderCell(params.row.meterUsage, true),
    renderHeader: () => renderHeader(t('allocations.utility_usage'), false)
  }, {
    field: 'serviceDays',
    align: 'left',
    flex: 0.25,
    minWidth: 90,
    maxWidth: 120,
    headerName: 'Days',
    headerAlign: 'left',
    renderCell: params => {
      if (!!params.row.serviceDaysInPeriod) {
        return renderCell(params.row.serviceDaysInPeriod);
      }
      if (params.row.startReadDate && params.row.endReadDate) {
        const daysValue = moment(new Date(params.row.endReadDate)).diff(moment(new Date(params.row.startReadDate)), 'days') + 1;
        params.row.serviceDays = daysValue;
        return renderCell(daysValue);
      } else {
        return renderCell('-');
      }
    },
    renderHeader: () => renderHeader(t('allocations.days_number'), false)
  }, {
    field: 'utilityUnit',
    align: 'left',
    flex: 0.25,
    minWidth: 80,
    headerName: 'Units of Measure',
    headerAlign: 'left',
    editable: !sentStatus,
    renderCell: params => renderCell(params.row.utilityUnit),
    renderHeader: () => renderHeader(t('allocations.units_of_measure'), false)
  }, {
    field: 'meterRate',
    align: 'left',
    flex: 0.25,
    minWidth: 90,
    maxWidth: 95,
    headerAlign: 'left',
    headerName: 'Rate',
    type: 'number',
    editable: !sentStatus,
    renderCell: params => /*#__PURE__*/React.createElement("div", {
      className: classes.cellContent,
      style: isNaN(Number(params.row.meterRate)) ? {
        justifyContent: 'center'
      } : {}
    }, !isNaN(Number(params.row.meterRate)) ? /*#__PURE__*/React.createElement(Typography, {
      variant: "body1"
    }, "$", Number(params.row.meterRate).toFixed(2)) : /*#__PURE__*/React.createElement(Typography, {
      variant: "body1",
      aligh: "center"
    }, isNaN(params.row.meterRate))),
    renderHeader: () => renderHeader(t('allocations.rate'), true)
  }, {
    field: 'utilityCharge',
    align: 'left',
    flex: 1,
    headerAlign: 'left',
    headerName: 'Allocated charge',
    minWidth: 100,
    maxWidth: 150,
    type: 'number',
    editable: !sentStatus,
    renderCell: params => /*#__PURE__*/React.createElement("div", {
      className: classes.cellContent
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "body1"
    }, "$", Number(params.row.utilityCharge).toFixed(2))),
    renderHeader: () => renderHeader(t('allocations.allocated_charge'), true)
  }, {
    field: 'actions',
    type: 'actions',
    headerName: 'Actions',
    width: 100,
    cellClassName: 'actions',
    getActions: _ref3 => {
      var _rowModesModel$id;
      let id = _ref3.id;
      const isInEditMode = ((_rowModesModel$id = rowModesModel[id]) === null || _rowModesModel$id === void 0 ? void 0 : _rowModesModel$id.mode) === GridRowModes.Edit;
      if (isInEditMode) {
        return [/*#__PURE__*/React.createElement(GridActionsCellItem, {
          icon: /*#__PURE__*/React.createElement(SaveIcon, null),
          label: "Save",
          sx: {
            color: 'primary.main'
          },
          onClick: handleSaveClick(id)
        }), /*#__PURE__*/React.createElement(GridActionsCellItem, {
          icon: /*#__PURE__*/React.createElement(CancelIcon, null),
          label: "Cancel",
          className: "textPrimary",
          onClick: handleCancelClick(id),
          color: "inherit"
        })];
      }
      return [/*#__PURE__*/React.createElement(GridActionsCellItem, {
        icon: /*#__PURE__*/React.createElement(EditIcon, null),
        label: "Edit",
        className: "textPrimary",
        onClick: handleEditClick(id),
        color: "inherit"
      })];
    }
  }];
  if (sentStatus) {
    const index = columns.findIndex(i => i.field === 'actions');
    if (index !== -1) {
      columns.splice(columns.findIndex(i => i.field === 'actions'), 1);
    }
  }
  return /*#__PURE__*/React.createElement(DataGrid, {
    autoHeight: true,
    columns: columns,
    disableRowSelectionOnClick: true,
    getRowClassName: () => classes.row,
    getRowId: row => {
      var _ref4, _row$accountId;
      return (_ref4 = (_row$accountId = row.accountId) !== null && _row$accountId !== void 0 ? _row$accountId : row.unitId) !== null && _ref4 !== void 0 ? _ref4 : row.residentAccountId;
    },
    rowsPerPageOptions: [5, 10, 20],
    onPageSizeChange: newPageSize => setPageSize(newPageSize),
    pagination: true,
    columnHeaderHeight: 95,
    rowHeight: 77,
    hideFooterSelectedRowCount: true,
    initialState: {
      sorting: {
        sortModel: [{
          field: 'unitName',
          sort: 'asc'
        }]
      }
    },
    pageSize: pageSize,
    rows: rows,
    editMode: "row",
    rowModesModel: rowModesModel,
    onRowModesModelChange: handleRowModesModelChange,
    onRowEditStop: handleRowEditStop,
    processRowUpdate: processRowUpdate,
    slotProps: {
      filterPanel: {
        filterFormProps: {
          columnInputProps: {
            variant: 'outlined'
          },
          operatorInputProps: {
            variant: 'outlined'
          }
        }
      }
    },
    slots: {
      ColumnMenuIcon: () => /*#__PURE__*/React.createElement("span", null),
      BaseButton: props => /*#__PURE__*/React.createElement(Button, _extends({}, props, {
        variant: "actionButton",
        'custom-attribute': '502-Submeter-csv-table-modal'
      })),
      BaseTextField: props => /*#__PURE__*/React.createElement(TextField, _extends({}, props, {
        variant: "outlined"
      }))
    }
  });
});
export default SubmeterCsvTableModal;